





import { Component, Vue } from 'vue-property-decorator'

/**
 * @title  基本
 * @desc 最基本的用法, 指定一个系统名称。
 */
@Component
export default class BasicExample extends Vue {
}
